import type {SignUpField} from '../../../Index.types'

import Styles from './CommunityFooter.module.css'

export interface CommunityFooterProps {
  label: string
  title: string
  description: string
  signUp: SignUpField
}

export const defaultProps: Partial<CommunityFooterProps> = {}

export const CommunityFooter = (props: CommunityFooterProps) => {
  const initializedProps: CommunityFooterProps = {...defaultProps, ...props}
  // eslint-disable-next-line no-empty-pattern
  const {} = initializedProps

  return <div className={Styles['CommunityFooter']}>CommunityFooter</div>
}
